module.exports = __webpack_public_path__ + "static/img/1.e03671c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/1.png
// module id = H4yT
// module chunks = 0